import apiService from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const productAPI = {
  getAllProducts: async (params: { page?: number; limit?: number; search?: string; categoryId?: string; minPrice?: string; maxPrice?: string }) => {
    const response = await apiService.get(API_ENDPOINTS.PRODUCT.GET_ALL, { params });
    return response.data;
  },
  
  getProductById: async (id: string) => {
    const response = await apiService.get(`${API_ENDPOINTS.PRODUCT.GET_BY_ID}/${id}`);
    return response.data;
  },
  
  createProduct: async (data: FormData, categoryId: string) => {
    const response = await apiService.uploadFile(`${API_ENDPOINTS.PRODUCT.CREATE}/${categoryId}`, data);
    return response.data;
  },
  
  updateProduct: async (id: string, data: FormData) => {
    const response = await apiService.axios.put(`${API_ENDPOINTS.PRODUCT.UPDATE}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
  
  deleteProduct: async (id: string) => {
    const response = await apiService.delete(`${API_ENDPOINTS.PRODUCT.DELETE}/${id}`);
    return response.data;
  },
  
  downloadCSV: async (params: { search?: string; categoryId?: string; minPrice?: string; maxPrice?: string }) => {
    const response = await apiService.get(API_ENDPOINTS.PRODUCT.GET_ALL, { 
      params: { csv: 'true', ...params },
      responseType: 'blob'
    });
    return response;
  },
};